import _ from 'lodash';
import { TravelTypes } from '../constants';
import formatTravelMode from './formatTravelMode';
import capitalize from './capitalize';
import formatCruisePayments from './formatCruisePayments';

const formatTrip = ({ trip, tripConfirmation }) => {
  const savedTrip = {};
  trip.tripSegments.forEach((tripSegment) => {
    if (tripSegment.mode === TravelTypes.cruise) {
      savedTrip.cruiseItinerary = tripSegment.itinerary;
      if (savedTrip.cruiseItinerary
        && savedTrip.cruiseItinerary.cabins
        && savedTrip.cruiseItinerary.cabins.length) {
        const cabins = [...savedTrip.cruiseItinerary.cabins];
        _.forEach(cabins, (cabin, index) => {
          cabins[index] = {
            ...cabin,
            selectedShipCabinCategory: {
              ...cabin.selectedShipCabinCategory,
              rateOptions: [cabin.selectedRateOption],
            },
          };
        });
        savedTrip.cruiseItinerary = {
          ...savedTrip.cruiseItinerary,
          cabins: [...cabins],
        };
      }
    } else if (tripSegment.mode === TravelTypes.flight) {
      savedTrip.flightItinerary = tripSegment.itinerary;
    } else if (tripSegment.mode === TravelTypes.hotel) {
      if (!savedTrip.hotelItineraries) savedTrip.hotelItineraries = [];
      if (!Array.isArray(savedTrip.selectedRoomCodes)) savedTrip.selectedRoomCodes = [];
      savedTrip.hotelItineraries = [
        ...savedTrip.hotelItineraries, tripSegment.itinerary,
      ];
      savedTrip.selectedRoomCodes.push(tripSegment.itinerary.selectedRoomCode);
    } else if (tripSegment.mode === TravelTypes.carrental) {
      savedTrip.rentalCarItineraries = {
        ...savedTrip.rentalCarItineraries,
        [tripSegment.itinerary.id]: tripSegment.itinerary,
      };
    } else if (tripSegment.mode === TravelTypes.custom) {
      savedTrip.customInventoryItinerary = tripSegment.itinerary;
    } else if (tripSegment.mode === TravelTypes.tour) {
      savedTrip.tourItinerary = tripSegment.itinerary;
    }
  });
  savedTrip.tripCode = trip.id;
  savedTrip.advisorEmail = trip.advisorEmail;
  savedTrip.brochureId = trip.brochureId;
  savedTrip.passengerCity = trip.passengerCity;
  savedTrip.id = trip.id;
  savedTrip.isUpdatingBookedTrip = trip.isUpdatingBookedTrip;
  savedTrip.isTripQuote = trip.isTripQuote;
  savedTrip.doAddItineraryInBookedTrip = trip.doAddItineraryInBookedTrip;
  savedTrip.doChangeItineraryInBookedTrip = trip.doChangeItineraryInBookedTrip;
  savedTrip.isCardSecurityCodeRequired = trip.isCardSecurityCodeRequired;
  savedTrip.isCardAddressRequired = trip.isCardAddressRequired;
  savedTrip.maxCharsNoteToAirDesk = trip.maxCharsNoteToAirDesk > 0
    ? trip.maxCharsNoteToAirDesk : undefined;
  savedTrip.doShowAgencyPlanningFeesPerPassenger = trip.doShowAgencyPlanningFeesPerPassenger;
  savedTrip.doShowNoteToAirDeskInput = trip.doShowNoteToAirDeskInput;
  savedTrip.doShowCompanyNameInput = trip.doShowCompanyNameInput;
  savedTrip.tripBookingFees = trip.tripBookingFees > 0
    ? trip.tripBookingFees : undefined;

  const uniqModes = _.uniq(_.map(trip.tripSegments,
    (ts) => capitalize(ts.mode === TravelTypes.custom
      ? ts.itinerary.type : formatTravelMode(ts.mode))));
  savedTrip.bookedModes = uniqModes.join(', ');
  savedTrip.bookedTravelTypes = _.uniq(_.map(trip.tripSegments, (ts) => ts.mode));
  savedTrip.separatePnrForTravelTypes = trip.separatePnrForTravelTypes;
  savedTrip.doSupportsCardUpsertOperations = trip.doSupportsCardUpsertOperations;

  if (tripConfirmation && tripConfirmation.trip && tripConfirmation.trip.cruisePayments) {
    savedTrip.cruisePayments = tripConfirmation.trip.cruisePayments;
  } else {
    savedTrip.cruisePayments = formatCruisePayments(tripConfirmation);
  }

  return savedTrip;
};

export default formatTrip;
